import React from "react";

import Tada from 'react-reveal/Tada';
import Flip from 'react-reveal/Flip';

const About = ({ data }) => {
  if (data) {
    var name = data.name;
    var profilepic = "images/" + data.image;
    var bio = data.bio;
    var street = data.address.street;
    var city = data.address.city;
    var state = data.address.state;
    var zip = data.address.zip;
    var phone = data.phone;
    var email = data.email;
    var resumeDownload = data.resumedownload;
  }

  return (
    <section id="about">
      
        <div className="row">
          <Flip right>

            <div className="three columns">
              <img
                className="profile-pic"
                src={profilepic}
                alt="Sonny's Profile Pic"
              />
            </div>
          </Flip>
          <div className="nine columns main-col">
            <Flip right>
              <h2>About Me</h2>
              <p>{bio}</p>
            </Flip>
            <div className="row">
              <Flip right>
                <div className="columns contact-details">
                  <h2>Contact Details</h2>
                  <p className="address">
                    <span>{name}</span>
                    <br />
                    <span>
                      {street}
                      <br />
                      {city} {state}, {zip}
                    </span>
                    <br />
                    <span>{phone}</span>
                    <br />
                    <span>{email}</span>
                  </p>
                </div>
              </Flip>
              <Tada>
              <div className="columns download">
                <p>
                  <a href={resumeDownload} className="button">
                    <i className="fa fa-download"></i>Download Resume
                  </a>
                </p>
              </div>
              </Tada> 
            </div>
          </div>
        </div>
      
    </section>
  );
};

export default About;
